import React, { useEffect, useState } from "react";

import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import AgentTree from "../components/AgentTree";
import { GetAdjustmentByType, GetAdjustment } from "../components/Adjust";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export default function DailyAM() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [totalLogs, setToTalLogs] = useState(null);
  const [vendors, setVendors] = useState(null);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const formatDate = (date) =>
    dayjs(date).tz("Asia/Seoul").format("YYYY-MM-DD");
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [startDate, setStartDate] = useState(formatDate(firstDayOfMonth));
  const [endDate, setEndDate] = useState(formatDate(lastDayOfMonth));

  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const [users, setUsers] = useState(null);
  const [Selectprefix, setSelectprefix] = useState(null);
  const [includeAll, setIncludeAll] = useState(false);

  // 년·월 선택 상태
  const [selectedYear, setSelectedYear] = useState(`${today.getFullYear()}`);
  const [selectedMonth, setSelectedMonth] = useState(
    (today.getMonth() + 1).toString().padStart(2, "0")
  );

  // 선택 옵션
  const years = [`${today.getFullYear()}`, `${today.getFullYear() - 1}`];
  const months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );

  // 연/월 변경 시 startDate, endDate 업데이트
  useEffect(() => {
    const year = parseInt(selectedYear, 10);
    const month = parseInt(selectedMonth, 10);
    const first = new Date(year, month - 1, 1);
    const last = new Date(year, month, 0);
    setStartDate(formatDate(first));
    setEndDate(formatDate(last));
  }, [selectedYear, selectedMonth]);

  const getVendors = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/Vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendors(res.data.vendor_list);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchTotalTransaction = async (prefix) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TotalTransactionByPrefix`, {
        params: {
          prefix: prefix,
          processed_at_start: startDate,
          processed_at_end: endDate,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setToTalLogs(res.data.rows);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchTotalTransactionAll = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${API_BASE}/api/TotalTransactionByPrefixAll`,
        {
          params: {
            prefix: users.Prefix,
            processed_at_start: startDate,
            processed_at_end: endDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setToTalLogs(res.data.rows);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/Users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(res.data);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };

    fetchUserInfo();
  }, []);

  const handleAgentClick = (prefix) => {
    setSelectprefix(prefix);
  };

  useEffect(() => {
    if (!Selectprefix) return;
    fetchTotalTransaction(Selectprefix);
  }, [Selectprefix, startDate, endDate]);

  useEffect(() => {
    if (!users) return;
    setSelectprefix(users.Prefix);
    getVendors();
  }, [users]);

  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block d-flex vReport">
              <div className="d-none d-xl-block w-25 me-1 mt-1">
                <div className="dropdown partnerTree">
                  <div className="dropdown-menu p-3 ps-1 d-block">
                    {users && (
                      <AgentTree user={users} onAgentClick={handleAgentClick} />
                    )}
                  </div>
                </div>
              </div>
              <div className="w-100 card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3 p-0">
                    <div className="nk-block nk-block-lg">
                      <div className="row tbSearch">
                        <div className="col-12 col-sm-12 col-xl-5">
                          <div className="form-group d-block d-xl-none">
                            <div
                              className="dropdown partnerTree"
                              includebelow="false"
                            ></div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 offset-md-6">
                          <div className="form-group withcontrol">
                            <div
                              className={`custom-control switch-onoff custom-switch ms-2${
                                includeAll ? " checked" : ""
                              }`}
                            >
                              <input
                                className="custom-control-input"
                                id="sw-treeAllSelect"
                                type="checkbox"
                                checked={includeAll}
                                onChange={(e) => {
                                  const next = e.target.checked;
                                  setIncludeAll(next);
                                  if (next) {
                                    // 하부포함 켜짐 → ALL 조회
                                    fetchTotalTransactionAll();
                                  } else {
                                    // 하부포함 꺼짐 → prefix 조회
                                    fetchTotalTransaction(users.Prefix);
                                  }
                                }}
                              />
                              <label
                                className="custom-control-label text-nowrap"
                                htmlFor="sw-treeAllSelect"
                              >
                                <strong>하부포함</strong>
                              </label>
                            </div>
                            <div className="form-control-wrap">
                              <select
                                className="form-select"
                                value={selectedYear}
                                onChange={(e) =>
                                  setSelectedYear(e.target.value)
                                }
                              >
                                {years.map((y) => (
                                  <option key={y} value={y}>
                                    {y}년
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="form-control-wrap">
                              <select
                                className="form-select"
                                value={selectedMonth}
                                onChange={(e) =>
                                  setSelectedMonth(e.target.value)
                                }
                              >
                                {months.map((m) => (
                                  <option key={m} value={m}>
                                    {m}월
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="nk-files-group user-days">
                  <div
                    className="table-wrapper"
                    style={{
                      borderTop: "1px dotted #BBB",
                      paddingTop: "5px 0",
                    }}
                  >
                    <div className="btn-toolbar justify-content-between"></div>
                    <div
                      className="table-responsive"
                      data-add-focus-btn="true"
                      data-fixed-nav-bar="true"
                      data-pattern="priority-columns"
                      data-sortable="true"
                    >
                      <table
                        cellSpacing="0"
                        className="table dataTable no-footer dtr-inline navbar-fixed-top"
                      >
                        <thead>
                          <tr data-pos-y="0">
                            <th data-pos-x="0" id="id6ab644ee1c6e78-col-0">
                              <span className="sub-text text-center">
                                게임사
                              </span>
                            </th>
                            <th data-pos-x="1" id="id6ab644ee1c6e78-col-1">
                              <span className="sub-text text-center">화폐</span>
                            </th>
                            <th data-pos-x="2" id="id6ab644ee1c6e78-col-2">
                              <span className="sub-text text-center">베팅</span>
                            </th>
                            <th data-pos-x="3" id="id6ab644ee1c6e78-col-3">
                              <span className="sub-text text-center">승</span>
                            </th>
                            <th data-pos-x="4" id="id6ab644ee1c6e78-col-4">
                              <span className="sub-text text-center">무</span>
                            </th>
                            <th data-pos-x="5" id="id6ab644ee1c6e78-col-5">
                              <span className="sub-text text-center">취소</span>
                            </th>
                            <th data-pos-x="6" id="id6ab644ee1c6e78-col-6">
                              <span
                                className="sub-text text-center"
                                data-bs-original-title="베팅 - (승 + 무 + 취소)"
                                data-bs-toggle="tooltip"
                              >
                                {" "}
                                Win/Lose{" "}
                                <em className="icon ni ni-info-fill vam" />
                              </span>
                            </th>
                            <th data-pos-x="7" id="id6ab644ee1c6e78-col-7">
                              <span
                                className="sub-text text-center"
                                data-bs-original-title="승 + 무 + 취소 / 베팅 * 100"
                                data-bs-toggle="tooltip"
                              >
                                {" "}
                                RTP
                                <em className="icon ni ni-info-fill vam" />
                              </span>
                            </th>
                            <th data-pos-x="8" id="id6ab644ee1c6e78-col-8">
                              <span className="sub-text text-center">
                                초과 당첨금
                              </span>
                            </th>
                            <th data-pos-x="9" id="id6ab644ee1c6e78-col-9">
                              <span className="sub-text text-center">
                                베팅수
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendors &&
                            vendors
                              .filter((v) => v.v_type === "casino")
                              .map((v, index) => (
                                <tr className="casino" key={index}>
                                  <td
                                    className="text-start"
                                    data-columns="id6ab644ee1c6e78-col-0"
                                    data-pos-x="0"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <span className="badge rounded-pill badge-dim bg-outline-primary">
                                      CASINO
                                    </span>
                                    <a href="#">{v.v_name_kor}</a>
                                  </td>
                                  <td
                                    className="text-center"
                                    data-columns="id6ab644ee1c6e78-col-1"
                                    data-pos-x="1"
                                  >
                                    KRW
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-2"
                                    data-pos-x="2"
                                  >
                                    {GetAdjustment(v, totalLogs).bet}
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-3"
                                    data-pos-x="3"
                                  >
                                    {GetAdjustment(v, totalLogs).win}
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-4"
                                    data-pos-x="4"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).tie}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-5"
                                    data-pos-x="5"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).cancle}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-6"
                                    data-pos-x="6"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).wl}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-7"
                                    data-pos-x="7"
                                  >
                                    {GetAdjustment(v, totalLogs).rtp}%
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-8"
                                    data-pos-x="8"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).overamount}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-9"
                                    data-pos-x="9"
                                  >
                                    {GetAdjustment(v, totalLogs).betCount}
                                  </td>
                                </tr>
                              ))}

                          <tr className="casino total" data-pos-y="15">
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-0"
                              data-pos-x="0"
                            >
                              카지노 합계
                            </td>
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-1"
                              data-pos-x="1"
                            >
                              KRW
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-2"
                              data-pos-x="2"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).bet
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-3"
                              data-pos-x="3"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).win
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-4"
                              data-pos-x="4"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).tie
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-5"
                              data-pos-x="5"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).cancle
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-6"
                              data-pos-x="6"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).wl
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-7"
                              data-pos-x="7"
                            >
                              {
                                GetAdjustmentByType(
                                  vendors,
                                  totalLogs,
                                  "casino"
                                ).rtp
                              }
                              %
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-8"
                              data-pos-x="8"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "casino"
                                  ).overamount
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-9"
                              data-pos-x="9"
                            >
                              {
                                GetAdjustmentByType(
                                  vendors,
                                  totalLogs,
                                  "casino"
                                ).betCount
                              }
                            </td>
                          </tr>
                          {vendors &&
                            vendors
                              .filter((v) => v.v_type === "slot")
                              .map((v, index) => (
                                <tr className="slot" key={index}>
                                  <td
                                    className="text-start"
                                    data-columns="id6ab644ee1c6e78-col-0"
                                    data-pos-x="0"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                      SLOT
                                    </span>
                                    <a href="#">{v.v_name_kor}</a>
                                  </td>
                                  <td
                                    className="text-center"
                                    data-columns="id6ab644ee1c6e78-col-1"
                                    data-pos-x="1"
                                  >
                                    KRW
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-2"
                                    data-pos-x="2"
                                  >
                                    {GetAdjustment(v, totalLogs).bet}
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-3"
                                    data-pos-x="3"
                                  >
                                    {GetAdjustment(v, totalLogs).win}
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-4"
                                    data-pos-x="4"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).tie}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-5"
                                    data-pos-x="5"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).cancle}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-6"
                                    data-pos-x="6"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).wl}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-7"
                                    data-pos-x="7"
                                  >
                                    {GetAdjustment(v, totalLogs).rtp}%
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-8"
                                    data-pos-x="8"
                                  >
                                    <span>
                                      {GetAdjustment(v, totalLogs).overamount}
                                    </span>
                                  </td>
                                  <td
                                    className="text-end"
                                    data-columns="id6ab644ee1c6e78-col-9"
                                    data-pos-x="9"
                                  >
                                    {GetAdjustment(v, totalLogs).betCount}
                                  </td>
                                </tr>
                              ))}
                          <tr className="slot total" data-pos-y="15">
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-0"
                              data-pos-x="0"
                            >
                              슬롯게임 합계
                            </td>
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-1"
                              data-pos-x="1"
                            >
                              KRW
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-2"
                              data-pos-x="2"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).bet
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-3"
                              data-pos-x="3"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).win
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-4"
                              data-pos-x="4"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).tie
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-5"
                              data-pos-x="5"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).cancle
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-6"
                              data-pos-x="6"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).wl
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-7"
                              data-pos-x="7"
                            >
                              {
                                GetAdjustmentByType(vendors, totalLogs, "slot")
                                  .rtp
                              }
                              %
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-8"
                              data-pos-x="8"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(
                                    vendors,
                                    totalLogs,
                                    "slot"
                                  ).overamount
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-9"
                              data-pos-x="9"
                            >
                              {
                                GetAdjustmentByType(vendors, totalLogs, "slot")
                                  .betCount
                              }
                            </td>
                          </tr>
                        </tbody>
                        <tfoot className="dt_user_view_total">
                          <tr>
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-0"
                              data-pos-x="0"
                            >
                              총합
                            </td>
                            <td
                              className="text-center"
                              data-columns="id6ab644ee1c6e78-col-1"
                              data-pos-x="1"
                            >
                              KRW
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-2"
                              data-pos-x="2"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .bet
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-3"
                              data-pos-x="3"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .win
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-4"
                              data-pos-x="4"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .tie
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-5"
                              data-pos-x="5"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .cancle
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-6"
                              data-pos-x="6"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .wl
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-7"
                              data-pos-x="7"
                            >
                              {
                                GetAdjustmentByType(vendors, totalLogs, "all")
                                  .rtp
                              }
                              %
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-8"
                              data-pos-x="8"
                            >
                              <span>
                                {
                                  GetAdjustmentByType(vendors, totalLogs, "all")
                                    .overamount
                                }
                              </span>
                            </td>
                            <td
                              className="text-end"
                              data-columns="id6ab644ee1c6e78-col-9"
                              data-pos-x="9"
                            >
                              {
                                GetAdjustmentByType(vendors, totalLogs, "all")
                                  .betCount
                              }
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
